import React, { ReactNode } from "react";
import { useDialog } from "../Dialogs";
import { ConfirmDeletionPopup } from "./ConfirmDeletionPopup";

export function useConfirmDeletion() {
  const { createDialog, closeDialog } = useDialog();

  return function (title: ReactNode) {
    return new Promise<true | false>(function (resolve) {
      createDialog({
        children: (
          <ConfirmDeletionPopup
            onCancel={() => {
              resolve(false);
              closeDialog("confirm-deletion-dialog");
            }}
            onConfirm={() => {
              resolve(true);
              closeDialog("confirm-deletion-dialog");
            }}
          >
            {title}
          </ConfirmDeletionPopup>
        ),
        name: "confirm-deletion-dialog",
      });
    });
  };
}
